import React from 'react'
import { useTranslation } from 'react-i18next'

const Help: React.FC = () => {
  const { t } = useTranslation()

  return (
    <div className="min-h-screen bg-background">
      <div className="max-w-3xl mx-auto px-4 py-8">
        <h1 className="text-2xl font-bold text-text mb-6">{t('nav.help')}</h1>

        <div className="space-y-6">
          <section className="bg-white rounded-2xl shadow-sm border border-border p-6">
            <h2 className="text-lg font-semibold text-text mb-3">{t('help.howToUse.title')}</h2>
            <ol className="list-decimal list-inside space-y-2 text-sm text-text-secondary">
              <li>{t('help.howToUse.step1')}</li>
              <li>{t('help.howToUse.step2')}</li>
              <li>{t('help.howToUse.step3')}</li>
              <li>{t('help.howToUse.step4')}</li>
              <li>{t('help.howToUse.step5')}</li>
              <li>{t('help.howToUse.step6')}</li>
              <li>{t('help.howToUse.step7')}</li>
            </ol>
          </section>

          <section className="bg-white rounded-2xl shadow-sm border border-border p-6">
            <h2 className="text-lg font-semibold text-text mb-3">{t('help.shortcuts.title')}</h2>
            <ul className="space-y-2 text-sm text-text-secondary">
              <li><kbd className="px-2 py-1 bg-border rounded text-xs">Ctrl</kbd> + <kbd className="px-2 py-1 bg-border rounded text-xs">P</kbd> {t('help.shortcuts.print')}</li>
              <li><kbd className="px-2 py-1 bg-border rounded text-xs">Ctrl</kbd> + <kbd className="px-2 py-1 bg-border rounded text-xs">S</kbd> {t('help.shortcuts.download')}</li>
            </ul>
          </section>

          <section className="bg-white rounded-2xl shadow-sm border border-border p-6">
            <h2 className="text-lg font-semibold text-text mb-3">{t('help.tips.title')}</h2>
            <ul className="list-disc list-inside space-y-2 text-sm text-text-secondary">
              <li>{t('help.tips.tip1')}</li>
              <li>{t('help.tips.tip2')}</li>
              <li>{t('help.tips.tip3')}</li>
              <li>{t('help.tips.tip4')}</li>
            </ul>
          </section>

          <section className="bg-white rounded-2xl shadow-sm border border-border p-6">
            <h2 className="text-lg font-semibold text-text mb-3">{t('help.features.title')}</h2>
            <p className="text-sm text-text-secondary mb-4">{t('help.features.intro')}</p>
            <div className="grid gap-4 md:grid-cols-2">
              <article className="rounded-xl border border-border p-4">
                <h3 className="font-semibold text-text mb-2">{t('help.features.printable.title')}</h3>
                <p className="text-sm text-text-secondary">{t('help.features.printable.content')}</p>
              </article>
              <article className="rounded-xl border border-border p-4">
                <h3 className="font-semibold text-text mb-2">{t('help.features.stroke.title')}</h3>
                <p className="text-sm text-text-secondary">{t('help.features.stroke.content')}</p>
              </article>
              <article className="rounded-xl border border-border p-4">
                <h3 className="font-semibold text-text mb-2">{t('help.features.pinyin.title')}</h3>
                <p className="text-sm text-text-secondary">{t('help.features.pinyin.content')}</p>
              </article>
              <article className="rounded-xl border border-border p-4">
                <h3 className="font-semibold text-text mb-2">{t('help.features.hsk.title')}</h3>
                <p className="text-sm text-text-secondary">{t('help.features.hsk.content')}</p>
              </article>
            </div>
          </section>

          <section className="bg-white rounded-2xl shadow-sm border border-border p-6">
            <h2 className="text-lg font-semibold text-text mb-3">{t('help.fontWorkflow.title')}</h2>
            <p className="text-sm text-text-secondary mb-4">{t('help.fontWorkflow.intro')}</p>
            <ol className="list-decimal list-inside space-y-2 text-sm text-text-secondary">
              <li>{t('help.fontWorkflow.step1')}</li>
              <li>{t('help.fontWorkflow.step2')}</li>
              <li>{t('help.fontWorkflow.step3')}</li>
              <li>{t('help.fontWorkflow.step4')}</li>
            </ol>
          </section>

          <section className="bg-white rounded-2xl shadow-sm border border-border p-6">
            <h2 className="text-lg font-semibold text-text mb-3">{t('help.privacySeo.title')}</h2>
            <p className="text-sm text-text-secondary">{t('help.privacySeo.content')}</p>
          </section>
        </div>
      </div>
    </div>
  )
}

export default Help
